/* Shared modal state for the custom menu and cart. */
(function () {
  var active = null;
  function close() {
    if (!active) return;
    var state = active; active = null;
    state.panel.removeEventListener('keydown', state.onKey);
    state.background.forEach(function (entry) { entry.node.inert = entry.inert; });
    document.documentElement.classList.remove('np-dialog-open');
    if (state.trigger && state.trigger.isConnected) state.trigger.focus({ preventScroll: true });
  }
  function open(panel, trigger, onEscape) {
    if (active) { var previous = active.onClose; close(); if (previous) previous(); }
    var background = [];
    Array.from(document.body.children).forEach(function (node) {
      if (node === panel || node.contains(panel) || node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
      background.push({ node: node, inert: node.inert }); node.inert = true;
    });
    function focusable() {
      return Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) { return !node.closest('[inert]') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'; });
    }
    function onKey(event) {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onEscape(); return; }
      if (event.key !== 'Tab') return;
      var nodes = focusable(), first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { event.preventDefault(); panel.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    active = { panel: panel, trigger: trigger || document.activeElement, background: background, onKey: onKey, onClose: onEscape };
    panel.addEventListener('keydown', onKey);
    document.documentElement.classList.add('np-dialog-open');
    var first = focusable()[0];
    if (first) first.focus({ preventScroll: true });
    else { panel.tabIndex = -1; panel.focus({ preventScroll: true }); }
  }
  window.NeoPlayDialogs = { open: open, close: close, release: function (root) { if (active && root.contains(active.panel)) close(); } };
  document.addEventListener('shopify:section:unload', function (event) { window.NeoPlayDialogs.release(event.target); });
})();
